import React, { Component } from 'react';
import ErrorPage from './ErrorPage';

interface ErrorBoundaryProps {
  children: React.ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
  error?: Error; // CS-1984: hold the caught error so it can be forwarded to the fallback
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: Error): ErrorBoundaryState {
    // return { hasError: true };          // CS-1984: also capture the error below
    return { hasError: true, error };       // CS-1984
  }

  // CS-1984: log the caught error + React errorInfo (componentStack) instead of swallowing it silently
  componentDidCatch(error: Error, errorInfo: React.ErrorInfo): void {
    console.error("ErrorBoundary caught an error:", error, errorInfo);
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      // CS-1984: forward the caught error to the fallback (the real ErrorPage ignores the prop — no UI change)
      // return <ErrorPage/>;
      const Fallback = ErrorPage as unknown as React.ComponentType<{ error?: Error }>; // CS-1984
      return <Fallback error={this.state.error} />; // CS-1984
    }

    return this.props.children;
  }
}



export default ErrorBoundary;
